(() => {
  if (customElements.get('aura-mini-product')) return;
  customElements.define('aura-mini-product', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const gallery = this.querySelector('.aura-mini-pdp__gallery');
      const thumbs = [...this.querySelectorAll('[data-mini-image-target]')];
      thumbs.forEach(button => button.addEventListener('click', () => {
        const image = document.getElementById(button.dataset.miniImageTarget);
        if (image && gallery) gallery.scrollTo({left: image.offsetLeft - gallery.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, {signal: this.controller.signal}));
      if (gallery && thumbs.length) {
        this.galleryObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => { if (entry.isIntersecting) thumbs.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.miniImageTarget === entry.target.id))); });
        }, {root: gallery, threshold: .65});
        gallery.querySelectorAll('figure').forEach(image => this.galleryObserver.observe(image));
      }
      const select = this.querySelector('[data-mini-variant]');
      const main = this.querySelector('[data-mini-main-atc]');
      const sticky = this.querySelector('[data-mini-sticky]');
      if (!select || !main) return;
      const update = () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true' && main.dataset.requiresPlan !== 'true';
        this.querySelectorAll('[data-mini-price], [data-mini-sticky-price]').forEach(el => el.textContent = option.dataset.price);
        const compare = this.querySelector('[data-mini-compare]');
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
        [main, this.querySelector('[data-mini-sticky-atc]')].filter(Boolean).forEach(button => {
          button.disabled = !available;
          button.textContent = main.dataset.requiresPlan === 'true' ? 'Purchase plan required' : available ? 'Add to bag' : 'Sold out';
        });
        const quantity = this.querySelector('[data-mini-quantity]');
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        quantity.value = quantity.min;
        if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
        const bundle = this.querySelector('[data-mini-bundle-link]');
        if (bundle) { const target = new URL(bundle.href); target.searchParams.set('scent', option.value); bundle.href = target.href; }
        const url = new URL(location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
        if (option.dataset.image) {
          const image = this.querySelector(`#AuraMiniImage-${CSS.escape(this.dataset.section)}-${CSS.escape(option.dataset.image)}`);
          if (image && matchMedia('(max-width: 1024px)').matches) image.parentElement.scrollTo({left: image.offsetLeft - image.parentElement.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          else if (image) image.parentElement.scrollTo({left: image.offsetLeft - image.parentElement.offsetLeft, behavior: 'auto'});
        }
      };
      select.addEventListener('change', update, {signal: this.controller.signal});
      this.observer = new IntersectionObserver(entries => {
        sticky.hidden = entries[0].isIntersecting;
      }, {threshold: 0});
      this.observer.observe(main);
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.galleryObserver?.disconnect(); }
  });
})();

(() => {
  if (window.auraNoteLinksReady) return;
  window.auraNoteLinksReady = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-aura-note-link]');
    if (!link) return;
    const note = document.getElementById(link.hash.slice(1));
    if (!note || note.tagName !== 'DETAILS') return;
    event.preventDefault();
    note.open = true;
    note.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'center'});
    note.querySelector('summary')?.focus({preventScroll:true});
  });
})();
